<script setup>
import axios from 'axios';
import { ref, onMounted } from 'vue';
import Paginator from '@/components/datatables/Paginator.vue';
import { formatCurrencyNoRM } from '../../helpers/function';

// state
const result = ref([]);
const loading = ref(false);
const filters = ref({
    search: '',
});
const errorMessage = ref('');

// methods
const fetchData = async (page = 1) => {
    loading.value = true;
    try {
        const response = await axios.get(`${process.env.VUE_APP_AR_API_BASEURL}customer/masterlisting`,{ 
            params: { page: page, key_search: filters.value.search } 
        });
        if (response.status != 200) {
            alert(response.data.message);
        }
        result.value = response.data;
    } catch (error) {
        console.error(error);
        errorMessage.value = 'Failed to load the data! Please try again later.';
    } finally {
        loading.value = false;
    }
};

const getOrderList = (orderDetails) => {
  if (!orderDetails) return [];
  console.log(orderDetails);
  return orderDetails.split('|').map(item => {
    const [orderId, curlecRef] = item.split(':');
    return { orderId: parseInt(orderId), curlecRef };
  });
};

const resetForm = () => {
    filters.value.search = '';
    errorMessage.value = '';
    fetchData();
};

const onSearchHandler = (e) => {
    e.preventDefault();    
    fetchData();
};

const showAR = () => {
    localStorage.setItem('showAr', 'yes')
}

// todo
// const downloadExcel = () =>{}

// lifecycle
onMounted(() => {
    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
    fetchData();
});


</script>

<template>
    <div>
        <!-- searching -->
        <div>
            <form @submit="onSearchHandler">
                <div class="row g-3 border-bottom-dashed border-bottom pb-3">
                    <div class="col-xl-8">
                        <div class="search-box">
                            <input type="text" class="form-control search"
                                placeholder="Search for Reference Number, Customer Name, Email" v-model="filters.search"/>
                            <i class="ri-search-line search-icon"></i>
                        </div>
                    </div>
                    <div class="col-xl-2">
                        <div>
                            <button type="submit" class="btn btn-primary w-100">
                                <i class="ri-equalizer-fill me-2 align-bottom"></i>Search
                            </button>
                        </div>
                    </div>
                    <div class="col-xl-2">
                        <div>
                            <button type="button" @click="resetForm" class="btn btn-danger w-100">
                                <i class="ri-refresh-fill me-2 align-bottom"></i>Reset
                            </button>
                        </div>
                    </div>
                </div>
            </form>

            <!-- <div class="card-body border-bottom-dashed border-bottom pb-3">
                <div class="row g-3 justify-content-end">
                    <div class="col-sm-auto">
                        <div>
                            <button  class="btn btn-success" v-if="this.role != 3"><i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel</button>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
        <div class="table-responsive mt-3">
            <table class="table table-striped table-nowrap mb-0">
                            <thead class="table-secondary">
                            <tr>
                                <th>#.</th>
                                <th scope="col">Reference Number(s)</th>   <!-- plural -->
                                <th scope="col">Customer Name</th>
                                <th scope="col">Email</th>
                                <th scope="col">Orders</th>               <!-- NEW -->
                                <th scope="col" style="text-align: right;">Total Outstanding (RM)</th>
                                <th scope="col">Action</th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr v-for="(item, index) in result.data" :key="item.nric">
                                <td>{{ index + result.from }}</td>

                                <!-- Curlec numbers (may be many) -->
                                <td>{{ item.curlec_refnos }}</td>

                                <td>
                                <router-link
                                    :to="'/customer/customer-details/' + item.customer_id"
                                    class="fw-medium link-secondary">
                                    {{ item.name_as_per_nric }}
                                </router-link>
                                </td>

                                <td>{{ item.email }}</td>

                                <!-- NEW column -->
                                <td class="text-center">{{ item.order_count }}</td>

                                <td style="text-align: right;">
                                {{ formatCurrencyNoRM(item.total_outstanding) }}
                                </td>

                        <td>
                            <div class="dropdown">
                                <button class="btn btn-soft-secondary btn-sm dropdown" type="button"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                <i class="ri-more-fill"></i>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                            <!-- View Customer -->
                                    <li @click="showAR()">
                                        <router-link class="dropdown-item"
                                            :to="'/customer/customer-details/' + item.customer_id">
                                <i class="ri-eye-fill align-bottom me-2 text-muted"></i>
                                View Customer Details
                                </router-link>
                                    </li>

                            <li v-if="item.order_count === 1">
                            <router-link class="dropdown-item"
                                        :to="'/ar/instantpay/' + getOrderList(item.order_details)[0].orderId">
                                <i class="ri-secure-payment-fill align-bottom me-2 text-muted"></i>
                                Generate Instant Pay
                                <small class="text-muted d-block">Ref: {{ getOrderList(item.order_details)[0].orderId }}</small>
                            </router-link>
                            </li>
                            <li v-else class="dropdown-submenu dropend">
                                <a class="dropdown-item dropdown-toggle" href="javascript:void(0);">
                                <i class="ri-secure-payment-fill align-bottom me-2 text-muted"></i>
                                Generate Instant Pay
                                <span class="badge bg-soft-primary ms-1">{{ item.order_count }}</span>
                                </a>
                                <ul class="dropdown-menu">
                                <template v-for="order in getOrderList(item.order_details)" :key="order.orderId">
                                    <li>
                                    <router-link class="dropdown-item"
                                                :to="'/ar/instantpay/' + order.orderId">
                                        Order #{{ order.orderId }}
                                    </router-link>
                                    </li>
                                </template>
                                <li v-if="item.order_count === 0">
                                    <span class="dropdown-item text-muted">No orders</span>
                                </li>
                                </ul>
                                    </li>
                                </ul>
                            </div>
                        </td>                                         
                    </tr>
                    <tr v-if="errorMessage">
                        <td colspan="6" style="text-align: center;">{{ errorMessage }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="mt-4" style="display: flex; justify-content: space-between; align-items: center;">
                <div>Showing {{ result.from }} to {{ result.to }} of {{ result.total }} results</div>
                <Paginator :data="result" :limit="1" @pagination-change-page="fetchData"></Paginator>
            </div>
        </div>
    </div>
</template>